export default {

  init() {
    this.handleSelectChange();
    this.handleRemoveFilter();
    this.searchMobileFilterToggle();
  },

  handleSelectChange() {
    $('select[data-js="submit"]').on('change', function(e) {
      let $select = $(this);
      let $form = $select.closest('form');
      if($form.length) {
        let $filters = $form.find('select, input').not($select).not('[type="hidden"]');
        $filters.each(function() {
          this.value = '';
        });
        $form.trigger('submit');
      }
    });
  },

  handleRemoveFilter() {
    $('[data-js="remove"]').on('click', function(e) {
      e.preventDefault();

      let $elem = $(this);
      let $form = $($elem.attr('data-form'));
      let target = $elem.attr('data-target');

      console.log($form);

      $form.find(`[name=${target}]`)[0].value = '';
      $form.trigger('submit');
    });
  },

  searchMobileFilterToggle(){
    // if(window.innerWidth < 768){
    //   $('.search__filter--headline').on('click', function(){
    //     if($(this).hasClass('is-sort')){
    //       $('.search__filter.is-sort').slideToggle();
    //     }
    //     if($(this).hasClass('is-filters')){
    //       $('.search__filter.is-filters').slideToggle();
    //     }
    //   });
    // }
  }

};
